import React, { useState } from 'react';
import { Container, Row, Col, Carousel, Image, Modal } from 'react-bootstrap';

// --- FOTOĞRAF BİLGİLERİ ---
const residentialProjects = [
  { id: 1, src: process.env.PUBLIC_URL + '/images/references/residential/1.jpeg', alt: 'Konut Projesi 1' },
  { id: 2, src: process.env.PUBLIC_URL + '/images/references/residential/2.jpeg', alt: 'Konut Projesi 2' },
  { id: 3, src: process.env.PUBLIC_URL + '/images/references/residential/3.jpeg', alt: 'Konut Projesi 3' },
  { id: 4, src: process.env.PUBLIC_URL + '/images/references/residential/4.jpeg', alt: 'Konut Projesi 4' },
  { id: 5, src: process.env.PUBLIC_URL + '/images/references/residential/5.jpeg', alt: 'Konut Projesi 5' },
  { id: 6, src: process.env.PUBLIC_URL + '/images/references/residential/6.jpeg', alt: 'Konut Projesi 6' },
  { id: 7, src: process.env.PUBLIC_URL + '/images/references/residential/7.jpeg', alt: 'Konut Projesi 7' },
  { id: 8, src: process.env.PUBLIC_URL + '/images/references/residential/8.jpeg', alt: 'Konut Projesi 8' },
  { id: 9, src: process.env.PUBLIC_URL + '/images/references/residential/9.jpeg', alt: 'Konut Projesi 9' },
  { id: 10, src: process.env.PUBLIC_URL + '/images/references/residential/10.jpeg', alt: 'Konut Projesi 10' },
  { id: 11, src: process.env.PUBLIC_URL + '/images/references/residential/11.jpeg', alt: 'Konut Projesi 11' },
];

const corporateProjects = [
  { id: 0, src: process.env.PUBLIC_URL + '/images/references/corporate/0.jpeg', alt: 'Kurumsal Proje 0' },
  { id: -1, src: process.env.PUBLIC_URL + '/images/references/corporate/-1.jpeg', alt: 'Kurumsal Proje -1' },
  { id: 1, src: process.env.PUBLIC_URL + '/images/references/corporate/1.jpeg', alt: 'Kurumsal Proje 1' },
  { id: 2, src: process.env.PUBLIC_URL + '/images/references/corporate/2.jpeg', alt: 'Kurumsal Proje 2' },
  { id: 3, src: process.env.PUBLIC_URL + '/images/references/corporate/3.jpeg', alt: 'Kurumsal Proje 3' },
  { id: 4, src: process.env.PUBLIC_URL + '/images/references/corporate/4.jpeg', alt: 'Kurumsal Proje 4' },
  { id: 5, src: process.env.PUBLIC_URL + '/images/references/corporate/5.jpeg', alt: 'Kurumsal Proje 5' },
  { id: 6, src: process.env.PUBLIC_URL + '/images/references/corporate/6.jpeg', alt: 'Kurumsal Proje 6' },
  { id: 7, src: process.env.PUBLIC_URL + '/images/references/corporate/7.jpeg', alt: 'Kurumsal Proje 7' },
  { id: 8, src: process.env.PUBLIC_URL + '/images/references/corporate/8.jpeg', alt: 'Kurumsal Proje 8' },
  { id: 9, src: process.env.PUBLIC_URL + '/images/references/corporate/9.jpeg', alt: 'Kurumsal Proje 9' },
  { id: 10, src: process.env.PUBLIC_URL + '/images/references/corporate/10.jpeg', alt: 'Kurumsal Proje 10' },
  { id: 11, src: process.env.PUBLIC_URL + '/images/references/corporate/11.jpeg', alt: 'Kurumsal Proje 11' },
  { id: 12, src: process.env.PUBLIC_URL + '/images/references/corporate/12.jpeg', alt: 'Kurumsal Proje 12' },
  { id: 13, src: process.env.PUBLIC_URL + '/images/references/corporate/13.jpeg', alt: 'Kurumsal Proje 13' },
  { id: 14, src: process.env.PUBLIC_URL + '/images/references/corporate/14.jpeg', alt: 'Kurumsal Proje 14' },
  { id: 15, src: process.env.PUBLIC_URL + '/images/references/corporate/15.jpeg', alt: 'Kurumsal Proje 15' },
  { id: 16, src: process.env.PUBLIC_URL + '/images/references/corporate/16.jpeg', alt: 'Kurumsal Proje 16' },
  { id: 17, src: process.env.PUBLIC_URL + '/images/references/corporate/17.jpeg', alt: 'Kurumsal Proje 17' },
  { id: 18, src: process.env.PUBLIC_URL + '/images/references/corporate/18.jpeg', alt: 'Kurumsal Proje 18' },
  { id: 19, src: process.env.PUBLIC_URL + '/images/references/corporate/19.jpeg', alt: 'Kurumsal Proje 19' },
  { id: 20, src: process.env.PUBLIC_URL + '/images/references/corporate/20.jpeg', alt: 'Kurumsal Proje 20' },
  { id: 21, src: process.env.PUBLIC_URL + '/images/references/corporate/21.jpeg', alt: 'Kurumsal Proje 21' },
  { id: 22, src: process.env.PUBLIC_URL + '/images/references/corporate/22.jpeg', alt: 'Kurumsal Proje 22' },
  { id: 23, src: process.env.PUBLIC_URL + '/images/references/corporate/23.jpeg', alt: 'Kurumsal Proje 23' },
  { id: 24, src: process.env.PUBLIC_URL + '/images/references/corporate/24.jpeg', alt: 'Kurumsal Proje 24' },
  { id: 25, src: process.env.PUBLIC_URL + '/images/references/corporate/25.jpeg', alt: 'Kurumsal Proje 25' },
];
// --- FOTOĞRAF BİLGİLERİ SONU ---


const Projects: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');

  const handleShowModal = (src: string) => {
    setSelectedImage(src);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedImage('');
  };

  return (
    <>
      <Container className="my-5">
        <Row className="text-center mb-5">
          <Col>
            <h2 className="display-5 fw-bold">Projelerimiz</h2>
            <p className="lead text-muted">Tamamladığımız bazı projeler.</p>
          </Col>
        </Row>

        {/* --- Konut Projeleri Slider --- */}
        <Row className="mb-5">
          <Col lg={{ span: 10, offset: 1 }}>
            <h3 className="mb-4 text-center">Konut</h3>
            <Carousel interval={3000} variant="dark">
              {residentialProjects.map(project => (
                <Carousel.Item key={project.id}>
                  <Image
                    className="d-block w-100"
                    src={project.src}
                    alt={project.alt}
                    style={{ height: '550px', objectFit: 'cover', width: '100%', backgroundColor: '#f8f9fa', borderRadius: '10px', cursor: 'pointer' }}
                    onClick={() => handleShowModal(project.src)}
                  />
                </Carousel.Item>
              ))}
            </Carousel>
          </Col>
        </Row>

        {/* --- Kurumsal Projeler Slider --- */}
        <Row>
          <Col lg={{ span: 10, offset: 1 }}>
            <h3 className="mb-4 text-center">Kurumsal</h3>
            <Carousel interval={3000} variant="dark">
              {corporateProjects.map(project => (
                <Carousel.Item key={project.id}>
                  <Image
                    className="d-block w-100"
                    src={project.src}
                    alt={project.alt}
                    style={{ height: '550px', objectFit: 'cover', width: '100%', backgroundColor: '#f8f9fa', borderRadius: '10px', cursor: 'pointer' }}
                    onClick={() => handleShowModal(project.src)}
                  />
                </Carousel.Item>
              ))}
            </Carousel>
          </Col>
        </Row>
      </Container>

      {/* --- Resim Görüntüleme Modalı --- */}
      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Image src={selectedImage} alt="Büyük Proje Fotoğrafı" fluid />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Projects;